class Chat {

    constructor() {
        this.tabs = new Tabs();
    }

    getRoomHeaderData(room) {

        let roomHeaderData = {
            individualRoomType: chatScreenController.INDIVIDUAL_ROOM,
            groupRoomType: chatScreenController.GROUP_ROOM,
            canalRoomType: chatScreenController.CANAL_ROOM,
            supportRoomType: chatScreenController.SUPPORT_ROOM
        };

        switch(room.type) {

            case chatScreenController.INDIVIDUAL_ROOM:
                roomHeaderData.type = chatScreenController.INDIVIDUAL_ROOM;
                roomHeaderData.backgroundColor = '#' + world.theme.color_1,
                roomHeaderData.textColor = '#' + world.theme.login_text_color,
                roomHeaderData.icon = room.user.icon ? room.user.icon : world.theme.user_icon;
                roomHeaderData.name = room.user.name;
                roomHeaderData.username = room.user.username;
                roomHeaderData.lastName = room.user.last_name;
                roomHeaderData.showHeaderBtn = world.profile_customization.show_opponent_profile && baseController.getTabById(this.tabs.CHAT_TAB) !== null;
                break;

            case chatScreenController.GROUP_ROOM:
                roomHeaderData.type = chatScreenController.GROUP_ROOM;
                roomHeaderData.backgroundColor = '#' + room.color,
                roomHeaderData.textColor = '#ffffff',
                roomHeaderData.icon = room.icon;
                roomHeaderData.title = room.title;
                roomHeaderData.numberOfUsers = room.users.length;
                break;

            case chatScreenController.CANAL_ROOM:
                roomHeaderData.type = chatScreenController.CANAL_ROOM;
                roomHeaderData.backgroundColor = '#' + room.color,
                roomHeaderData.textColor = '#ffffff',
                roomHeaderData.icon = room.icon;
                roomHeaderData.title = room.title;
                break;

            case chatScreenController.SUPPORT_ROOM:
                roomHeaderData.type = chatScreenController.SUPPORT_ROOM;
                roomHeaderData.assistantUser = user.user_chat_is_assistant;
                roomHeaderData.showHeaderBtn = world.profile_customization.show_opponent_profile;
                break;

        }

        if (room.type === chatScreenController.SUPPORT_ROOM) {

            if (user.user_chat_is_assistant) {
                roomHeaderData.backgroundColor = '#' + world.theme.color_1,
                roomHeaderData.textColor = '#' + world.theme.login_text_color,
                roomHeaderData.icon = room.user.icon ? room.user.icon : world.theme.user_icon;
                roomHeaderData.name = room.user.name;
                roomHeaderData.username = room.user.username;
                roomHeaderData.lastName = room.user.last_name;
            } else {
                roomHeaderData.backgroundColor = '#' + world.theme.support_color,
                roomHeaderData.textColor = '#ffffff',
                roomHeaderData.icon = world.theme.support_avatar;
                roomHeaderData.title = world.theme.support_name;
            }

        }

        return roomHeaderData;

    }

    getSupportCanvasData() {
        try {
            let unreadMessagesData = $.parseJSON(storage.getItem('chat_unread_messages'));
            let unreadUserMessages = unreadMessagesData ? unreadMessagesData.unreadUserMessages : 0;
            let unreadSupportMessages = unreadMessagesData ? unreadMessagesData.unreadSupportMessages : 0;

            return {
                enabled: world.chat_support_enabled,
                assistantUser: user.user_chat_is_assistant,
                assistantView: chatScreenController.assistantView,
                icon: world.theme.support_avatar,
                borderColor: '#' + world.theme.support_color,
                unreadSupportMessages: unreadSupportMessages,
                unreadUserMessages: unreadUserMessages
            }
        } catch (e) {
            console.error(e);

            return {};
        }
    }

    getChatListData(rooms, isSearchResult) {

        return {

            rooms: rooms,
            isSearchResult: isSearchResult,
            user_world_id: user?.user_world_id,
            chat_customization: world?.chat_customization,
            defaultUserIcon: world.theme?.user_icon,
            friendsCustomization: baseController.userCustomization(),
            supportCanvasData: this.getSupportCanvasData(),
            shareProjectDocument: chatScreenController.modalShareChatDocument.modalOpen,
            userInfoChatMobile: chatScreenController.modalShareChatDocument.modalOpen && detectmob()

        };

    }

    getNewEmptyRoom(user, roomType) {

        return {

            type: roomType,
            user_pointer: 0,
            other_user_pointer: 0,
            total_unread_messages: 0,
            last_message: null,
            user: {
                id: null,
                category_item: user.category_item,
                chat_notifications: user.chat_notifications,
                connected: user.connected,
                following: user.following,
                followers: user.followers,
                pending_challenges: user.pending_challenges,
                user_world_id: user.user_world_id,
                icon: user.user_icon,
                username: user.username,
                name: user.name,
                last_name: user.last_name,
                level_icon: user.level ? user.level.icon : null,
                rank: user.user_rank,
                phone: user.phone,
                email: user.email
            }

        }

    }

    createNewRoom(user, firstMessage, roomType) {

        return {

            id: firstMessage.room_id,
            last_message: firstMessage,
            total_unread_messages: 1,
            user_pointer: 0,
            other_user_pointer: firstMessage.id,
            type: roomType,
            user: user

        }

    }

    createHTMLMessage(showMessageTime, showMessageDate, lastSendUserData, newMessageObj) {

        let htmlMessage = {
            individualRoomType: chatScreenController.INDIVIDUAL_ROOM,
            groupRoomType: chatScreenController.GROUP_ROOM,
            canalRoomType: chatScreenController.CANAL_ROOM,
            supportRoomType: chatScreenController.SUPPORT_ROOM,
            textMessageType: chatScreenController.TEXT_MESSAGE_TYPE,
            userDocumentMessageType: chatScreenController.USER_DOCUMENT_TYPE,
            projectDocumentMessageType: chatScreenController.PROJECT_DOCUMENT_TYPE,
            messageId: newMessageObj.id,
            noPermissionsDocumentIcon: customIcons["DOCUMENTATION_BOTTOM_NAVIGATION_SHARE"],
            userDocumentData: newMessageObj.userDocumentData,
            projectDocumentData: newMessageObj.projectDocumentData,
            roomType: chatScreenController.room.type,
            messageType: newMessageObj.type,
            showMessageTime: showMessageTime,
            showMessageDate: showMessageDate,
            hourFormatted: ChatScreenController.formatLocaleDate(newMessageObj.send_date, 'HH:mm'),
            dateFormatted: ChatScreenController.formatLocaleDate(newMessageObj.send_date, 'DD MMMM'),
            payload: newMessageObj.payload,
            messagePosition: user.user_world_id !== newMessageObj.user_world_id ? 'left' : 'right',
            roomHeaderColor: $('.top-chat-info-data').css('background-color'),
            roomTextColor: $('.top-chat-info-back-btn').css('color'),
            isReadMessage: chatScreenController.room.other_user_pointer >= newMessageObj.id
        };

        if (chatScreenController.room.type === chatScreenController.GROUP_ROOM) {
            if (newMessageObj.user_world_id === user.user_world_id) {
                htmlMessage.transmitterUser = true;
            } else if (lastSendUserData) {
                htmlMessage.transmitterUser = false;
                htmlMessage.username = lastSendUserData.username;
                htmlMessage.userIcon = lastSendUserData.icon ? lastSendUserData.icon : world.theme.user_icon;
            }
        }

        if (newMessageObj.type === chatScreenController.USER_DOCUMENT_TYPE) {

            if (newMessageObj.userDocumentData.type === '1') {
                htmlMessage.userDocumentType = 'image';
            } else if (newMessageObj.userDocumentData.type === '2') {
                htmlMessage.userDocumentType = 'video';
            } else {
                htmlMessage.userDocumentType = 'doc';
            }
        }

        return htmlMessage;

    }

    createMessage(messageData) {

        let newMessage = {
            id: messageData.message.id,
            room_id: messageData.message.room_id,
            send_date: messageData.message.send_date,
            receive_date: messageData.message.send_date,
            user_world_id: messageData.user_world_id,
            user_worlds_ids: messageData.user_worlds_ids,
            user_id: messageData.message.user_id,
            type: messageData.message.type,
            payload: messageData.message.payload,
            userDocumentData: messageData.message.userDocumentData,
            projectDocumentData: messageData.message.projectDocumentData
        }

        return newMessage;

    }

    setDirectoryData(chatItem, directoryData) {

        chatItem.user.following = directoryData.following;
        chatItem.user.connected = directoryData.connected;
        chatItem.user.chat_notifications = directoryData.chat_notifications;
        chatItem.user.pending_challenges = directoryData.pending_challenges;
        chatItem.user.followers = directoryData.followers;
        chatItem.user.icon = directoryData.user_icon;

    }

}